<template>

</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
          fncDepartmentAdd() {
              this.$store.dispatch('fncPopulateUserRegions');
				var modalDetails = { title: 'Add Department', component: 'modal-department-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadNotifications() {
           /* this.$store.commit('fncEmptyDepartments');
            this.$store.dispatch({
              type: 'fncPopulateDepartments',
              reload: true
            })*/
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
